const Skeleton = ({ className }: { className: string }) => {
  return (
    <div className="mb-2 flex w-full animate-pulse flex-col gap-2 pt-1">
      <div className={`rounded-md bg-gray-200 ${className}`}></div>
    </div>
  );
};

export default Skeleton;
